import { AuthError, defineView } from '@juvare/platform-app/App';
import { columns } from './types';
import { viewQuery } from './viewQuery';
export const accountTrainCoursesViewName = 'accountTrainCourses';
export const accountTrainCoursesView = defineView({
    columns,
    viewQuery,
    orderByColumn: 'completionDate',
    orderByDesc: true,
    onAuthList: () => {
        // to be called only internally
        throw new AuthError('Unauthorized');
    },
});
